import { motion } from "framer-motion";
import { Send, Bell, Gift } from "lucide-react";

export const TelegramCta = () => {
  return (
    <section className="bg-white pb-16 sm:pb-20" data-testid="telegram-cta-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-3xl bg-[#229ED9] p-8 text-white shadow-xl sm:p-12"
        >
          <Send className="absolute -right-8 -top-8 h-48 w-48 -rotate-12 text-white/10" aria-hidden />
          <div className="relative max-w-xl space-y-4">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide">
              <Bell className="h-3.5 w-3.5" /> Gratis, ogni giorno alle 18:00
            </span>
            <h2 className="font-display text-2xl font-bold tracking-tight sm:text-3xl" data-testid="telegram-cta-title">
              Un'idea al giorno sulle emozioni dei bambini, direttamente su Telegram
            </h2>
            <p className="text-sm leading-relaxed text-white/85 sm:text-base">
              Sul canale <span className="font-semibold">@ioemozione</span> trovi ogni giorno un'attività, un estratto del quaderno o un regalo da scaricare. Zero spam, solo cose utili per genitori e insegnanti.
            </p>
            <a
              href="https://t.me/ioemozione"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="telegram-join-button"
              className="inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 font-display text-base font-bold text-[#229ED9] shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl sm:text-lg"
            >
              <Send className="h-5 w-5" /> Segui il canale gratis
            </a>
            <p className="flex items-center gap-1.5 text-xs text-white/70">
              <Gift className="h-3.5 w-3.5" /> Per iscriverti serve solo l'app Telegram, gratuita
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
